import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { useAuth } from "@utils/firebaseAuth/auth";
import { router } from "expo-router";

const SettingsButton = () => {
  const { status: authStatus } = useAuth();
  const isLoggedIn = authStatus === "logged-in";

  if (!isLoggedIn) return null;
  return (
    <LPressable
      accessibilityHint="Opens account settings"
      accessibilityLabel="Settings"
      accessibilityRole="button"
      fadeEnabled
      onPress={() => {
        router.navigate("/(app)/(tabs)/profile/settings");
      }}
      sentryEventName="settings_open"
      style={{
        alignItems: "center",
        height: 48,
        justifyContent: "center",
        width: 48,
      }}
      testID="settings"
    >
      <LIcon name="settings" size={26} />
    </LPressable>
  );
};

export default SettingsButton;
